import INSTAGRAM from "../../assets/images/instagram.svg";
import INSTAGRAM_COLORED from "../../assets/images/insta-active.svg";
import LINKEDIN from "../../assets/images/linkedin.svg";
import LINKEDIN_COLORED from "../../assets/images/linkedin-active.svg";
import TWITTER from "../../assets/images/tw-default.svg";
import TWITTER_COLORED from "../../assets/images/tw-active.svg";

const SOCIAL_LINK_ARRAY = [
  {
    id: 1,
    name: "Linkedin",
    logo: LINKEDIN,
    hoverIcon: LINKEDIN_COLORED,
    redirectTo: " https://www.linkedin.com/company/borrowland/",
  },
  {
    id: 2,
    name: "Instagram",
    logo: INSTAGRAM,
    hoverIcon: INSTAGRAM_COLORED,
    redirectTo: "https://www.instagram.com/borrowland_org/",
  },
  {
    id: 3,
    name: "Twitter",
    logo: TWITTER,
    hoverIcon: TWITTER_COLORED,
    redirectTo: "https://twitter.com/borrowland_org",
  },
];

export default SOCIAL_LINK_ARRAY;
